import { render, staticRenderFns } from "./InputMoeda.vue?vue&type=template&id=4202f753&"
import script from "./InputMoeda.vue?vue&type=script&lang=js&"
export * from "./InputMoeda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports